"use strict";

export function initInScope ($scope) {
    $scope.find('.js-ajax-form--scroll').on('success.ajax-form', (evt) => {
        $('html, body').animate({
            scrollTop: $('.js-ajax-form__result').offset().top - 25
        }, 750);
        $scope.find('[data-toggle="tooltip"]').tooltip();
    });
}